// 시즌 캘린더 v1 — 구체 일자는 공식 공고 확인. 합격선 없음.
export const calendarMeta = {
  title: '시즌 일정',
  lede:
    '한 해 입시 흐름을 시즌 단위로 잡아 둡니다. 정확한 시험일·마감은 아래 공식 링크의 해당 연도 공고로 확인하세요.',
  updatedAt: '2026-07',
};

export const seasonBlocks = [
  {
    id: 'eju-june',
    season: '상반기',
    title: 'EJU 제1회 (통상 6월)',
    approx: '6월 실시 · 성적 통지는 시험 후 수주',
    actions: [
      '해당 연도 JASSO EJU 일정·출원 기간 확인',
      '지망교 요강의 EJU 지정 회차와 맞는지 대조',
      '2026년도부터 기초학력 시라버스 개정 적용 여부 확인',
    ],
    links: [
      { label: 'JASSO EJU', url: 'https://www.jasso.go.jp/ryugaku/eju/index.html' },
      {
        label: '시라버스 개정',
        url: 'https://www.jasso.go.jp/ryugaku/eju/about/revision/index.html',
      },
    ],
  },
  {
    id: 'eju-nov',
    season: '하반기',
    title: 'EJU 제2회 (통상 11월)',
    approx: '11월 실시 · 이듬해 출원에 쓰는 경우 많음',
    actions: [
      '제2회 출원·시험일 공식 공고 확인',
      '봄·가을 입학 요강의 인정 회차와 매칭',
      '영어 외부시험 유효기간이 출원까지 남는지 점검',
    ],
    links: [
      { label: 'JASSO EJU', url: 'https://www.jasso.go.jp/ryugaku/eju/index.html' },
    ],
  },
  {
    id: 'kyotsu',
    season: '연말–연초',
    title: '대학입학공통테스트 시즌',
    approx: '실시일은 해당 연도 DNC 공고',
    actions: [
      '일반선발 지망이면 DNC에서 시험일·출원 일정 확인',
      '대학 요강의 공통테스트 이용 과목 표 작성',
      '본고사(개별학력검사) 일정과 겹침 없는지 확인',
    ],
    links: [
      { label: 'DNC 공통테스트', url: 'https://www.dnc.ac.jp/kyotsu/' },
      { label: 'Web 출원 안내', url: 'https://www.dnc.ac.jp/kyotsu/web_syutugan.html' },
    ],
  },
  {
    id: 'mext',
    season: '봄–여름 (공고 기준)',
    title: '국비(MEXT) 학부 공고 확인 창',
    approx: '한국은 주한일본대사관 연도 공고가 기준',
    actions: [
      '대사관 국비 안내·최신 공고 목록 열기',
      '대사관 추천 vs 대학 추천 중 어느 쪽인지 정하기',
      '사비 EJU/일반 병행 일정 비워 두기',
    ],
    links: [
      {
        label: '주한일본대사관 국비',
        url: 'https://www.kr.emb-japan.go.jp/itpr_ko/study_government.html',
      },
      {
        label: 'Study in Japan MEXT 학부',
        url: 'https://www.studyinjapan.go.jp/en/smap-stopj-applications-undergraduate.html',
      },
    ],
  },
  {
    id: 'apply-peak',
    season: '가을–겨울 / 봄',
    title: '대학 출원·면접 성수기',
    approx: '학부·전형마다 다름 — 요강 캘린더가 최종',
    actions: [
      '관심 대학 3곳 요강 PDF의 접수·필착·시험일 표 만들기',
      '요강 체크리스트·해외출원 항목 점검',
      '검정료·서류·영어 직송 마감 역산',
    ],
    links: [
      { label: '요강 체크리스트', path: '/checklist' },
      { label: '루트 파인더', path: '/finder' },
    ],
  },
];
